import React, { useEffect, useState, useMemo } from "react";
import Banner from "src/assets/images/website-images/life-health-package-banner.png";
import HealthPackageTabCard from "src/Components/WebsiteComponents/HomePage/Cards/HealthPackageTabCard";
import httpRequest from "src/helpers/httpRequest";
import { HealthPackage } from "src/types/GlobalInterfaces";
import { toast } from "react-toastify";
import { useQueryParams } from "src/hooks/useQueryParams";
import { parseQueryParams } from "src/helpers/helperFunctions";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { QueryPath } from "src/lib/constans";

const AllHealthPackagesPage = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [data, setData] = useState<HealthPackage[]>([]);
  const navigate = useNavigate();
  const queryParams = useQueryParams();
  const search = queryParams.getParam(QueryPath.search) || "";

  const fetchPackages = async () => {
    if (data.length === 0) {
      setLoader(true);
    }
    const { res, err } = await httpRequest<{ documents: HealthPackage[] }>({
      path: `/product/all-diagnostic-packages?${parseQueryParams({ search })}`,
    });
    if (res) {
      setData(res?.documents || []);
    } else {
      toast(err, { type: "error" });
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchPackages();
  }, [search]);

  // Memoize the rendered cards to prevent unnecessary re-renders
  const renderedCards = useMemo(() => {
    if (loader) {
      return Array.from({ length: 3 }).map((_, index) => (
        <HealthPackageTabCard key={`Skeleton-${index}`} skeleton />
      ));
    }
    return data.map((item, index) => (
      <HealthPackageTabCard
        key={index}
        data={item}
        id={`health-package-tab-card-${index}`}
      />
    ));
  }, [loader, data]);

  return (
    <div className="bg-banner-white-image w-full h-full relative 2xl:p-4 p-2">
      <div className="view-area-width mx-auto box-design bg-white flex flex-col 2xl:gap-6 gap-4 2xl:p-4 p-2">
        <img
          src={Banner}
          alt="Banner"
          className="w-full max-h-[44vh] object-cover box-design rounded-lg"
          loading="lazy" // Lazy load the image
        />
        {search && (
          <div className="flex items-center font-Poppins-Regular font-size-18px">
            Search Result For : <span className="font-Poppins-Medium ml-2 font-size-14px">({search})</span>{" "}
            <button
              className="font-Poppins-Regular ml-2 font-size-14px bg-[#434243] text-white px-2 py-1 rounded-md"
              onClick={() => navigate(`/health-packages`)}
            >
              View All
            </button>
          </div>
        )}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 gap-y-6">
          {renderedCards}
        </div>
      </div>
    </div>
  );
};

export default AllHealthPackagesPage;
